<template>
  <div>
    <b-container fluid>
      <b-button class="mb-3" @click="$router.go(-1)" variant="outline-dark">
        <b-icon-arrow-bar-left size="lg"></b-icon-arrow-bar-left>
        Back
      </b-button>
      <b-row>
        <b-col class="text-center">
          <h1 class="text-center">
            Add Test
            {{ $route?.query?.domain == "base" ? "Institution" : "Group" }}
          </h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <form @submit.prevent="$route.params.trackid ? setInstitution() : addInst()">
            <b-overlay :show="uploading || fetching" rounded="sm">
              <template #overlay>
                <div class="text-center">
                  <b-icon-circle font-scale="3" animation="throb"></b-icon-circle>
                  <p>Creating Testgroup...</p>
                </div>
              </template>
              <b-card v-if="!fetching" bg-variant="light">
                <b-form-group>
                  <div
                    v-if="institutionadded"
                    class="alert alert-dismissible alert-success p-3"
                  >
                    Testgroup has been Updated
                  </div>

                  <b-form-group label-for="institution">
                    <p class="form-label">
                      {{
                        `Test ${
                          $route?.query?.domain == "base" ? "Institution" : "Group"
                        } Full Name:`
                      }}
                    </p>
                    <b-form-input
                      v-model="institution.name"
                      id="institutionname"
                      placeholder=""
                      required
                    >
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="institutionsname">
                    <p class="form-label">
                      {{
                        `Test ${
                          $route?.query?.domain == "base" ? "Institution" : "Group"
                        } Short Name:`
                      }}
                    </p>
                    <b-form-input
                      v-model="institution.sname"
                      id="institutionsname"
                      placeholder=""
                      required
                    >
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    v-if="$route?.query?.domain == 'base' || this.details.clearance_organization == 'Quicktest'"
                    class="nested-form-group"
                    label=""
                    label-for="category"
                  >
                    <p class="form-label">
                      Select The Exam Category/Exam Type of the Institution :
                    </p>
                    <b-form-select
                      v-model="institution.category"
                      :options="categoryarr"
                      @change="categoryChanged"
                    >
                      <b-form-select-option value="null"
                        >--Select category--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group v-if="details.category != 'Organization'"  label="">
                    <div class="tooltip-wrapper">
                      <p class="form-label">Test group Structure</p>
                      <b-icon-info-circle-fill
                        id="tooltip-structure-1"
                        class="mt-1 cursor-pointer"
                      ></b-icon-info-circle-fill>
                      <b-tooltip
                        target="tooltip-structure-1"
                        custom-class="tooltip"
                        style="width: 500px"
                        triggers="hover"
                      >
                        <span class="info-span"
                          >*Structure is the way in which all
                          {{ $route?.query?.domain == "base" ? "Institution" : "Group" }}
                          under this Exam Category Serves its Candidates its Tests</span
                        ><br />
                        <span class="info-span"
                          >*There are two options, the Subject Structure and Section
                          Structure</span
                        ><br />
                        <span class="info-span"
                          >*In the Subject Structure, more than 1 Subject can be written
                          at a sitting or in the Testhall at a time.</span
                        ><br />
                        <span class="info-span"
                          >*In the Section Structure, Only 1 Course can be written at a
                          time with underlying Sections cutting through the whole
                          course.</span
                        ><br />
                        <span class="info-span"
                          >*If you have any Structure not listed here, Please Contact the
                          Quicktest Development Team @ quicktestng@gmail.com</span
                        >
                      </b-tooltip>
                    </div>

                    <b-form-select v-model="institution.structure">
                      <b-form-select-option value="null"
                        >--Select Structure--
                      </b-form-select-option>
                      <b-form-select-option value="Untabbed"
                        >Untabbed</b-form-select-option
                      >
                      <b-form-select-option value="Subject">Subject</b-form-select-option>
                      <b-form-select-option value="Section">Section</b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group  label="">
                    <div class="tooltip-wrapper">
                      <p class="form-label">is Available?</p>
                      <b-icon-info-circle-fill
                        id="tooltip-available-1"
                        class="mt-1 cursor-pointer"
                      ></b-icon-info-circle-fill>
                      <b-tooltip
                        target="tooltip-available-1"
                        custom-class="tooltip"
                        style="width: 500px"
                        triggers="hover"
                      >
                        <span class="info-span"
                          >*Is the
                          {{ $route?.query?.domain == "base" ? "Institution" : "Group" }}
                          available for Testspaces to access after it has been added?</span
                        ><br />
                        <span class="info-span"
                          >*If the
                          {{ $route?.query?.domain == "base" ? "Institution" : "Group" }}
                          is been added so that questions can be uploaded, it is advisable
                          to select "No" now and then Edit it to Yes when question upload
                          has been Finalized</span
                        >
                      </b-tooltip>
                    </div>

                    <b-form-select v-model="institution.available">
                      <b-form-select-option value="null"
                        >--Is
                        {{ $route?.query?.domain == "base" ? "Institution" : "Testgroup" }}
                        Ready for Use?--
                      </b-form-select-option>
                      <b-form-select-option value="Yes">Yes</b-form-select-option>
                      <b-form-select-option value="No">No</b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="institution.structure == 'Section'"
                    label="Subgroup's Label"
                  >
                    <b-form-select
                      v-model="institution.label"
                      :options="classificationarray"
                    >
                      <b-form-select-option value="null"
                        >--Select Label--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="institution.structure == 'Section'"
                    label="Label arrangment style"
                  >
                    <b-form-select
                      v-model="institution.label_arrangement"
                      :options="arrangmentarray"
                    >
                      >
                      <b-form-select-option value="null"
                        >--Select Arrangment--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group v-if="institution.structure == 'Section'">
                    <b-form-group label-for="levels">
                      <div class="tooltip-wrapper">
                        <p>
                          Enter the
                          {{ `${institution.label}s e.g 100, 200 etc` }}
                        </p>
                        <b-icon-info-circle-fill
                          id="tooltip-morelabels-1"
                          class="mt-1 cursor-pointer"
                        ></b-icon-info-circle-fill>
                        <b-tooltip
                          target="tooltip-morelabels-1"
                          custom-class="tooltip"
                          style="width: 500px"
                          triggers="hover"
                        >
                          <span class="info-span"
                            >*Input the {{ institution.label }} you want your Test to be
                            Administered to</span
                          ><br />
                          <span class="info-span"
                            >* Customize it to how you categorize your
                            Students/Users.</span
                          >
                        </b-tooltip>
                      </div>

                      <b-form-tags
                        id="levels"
                        :placeholder="`Add ${institution.label}s`"
                        @input="addLevels($event)"
                        v-model="institution.levels"
                      ></b-form-tags>
                    </b-form-group>

                    <div v-if="institution.levels.length > 0">
                      <div
                        v-for="(level, index) in institution.levels"
                        :key="index"
                        :ref="level"
                        @mouseenter="setLevel(level)"
                        @touchstart="setLevel(level)"
                        class="mt-5"
                      >
                        <b-form-group class="level-wrapper">
                          <div class="head-wrapper">
                            <h4>
                              Configurations for
                              {{
                                institution.label_arrangement == "prefix"
                                  ? institution.label
                                  : ""
                              }}
                              {{ level }}
                              {{
                                institution.label_arrangement == "suffix"
                                  ? institution.label
                                  : ""
                              }}
                              Subgroup
                            </h4>

                            <b-icon-plus-lg
                              v-if="!getVisible(level)"
                              style="margin-top: 10px"
                              class="cursor-pointer"
                              @click="closeVisible(level)"
                            ></b-icon-plus-lg>
                            <b-icon-dash-lg
                              v-if="getVisible(level)"
                              style="margin-top: 10px"
                              class="cursor-pointer"
                              @click="closeVisible(level)"
                            ></b-icon-dash-lg>
                          </div>

                          <div v-if="getVisible(level)" class="mt-3">
                            <h6 class="mb-3">
                              Input all that Apply for this Sub
                              {{
                                $route?.query?.domain == "base" ? "Institution" : "Group"
                              }}
                              in the Correct Order

                              <b-tooltip
                                target="tooltip-morelabels-1"
                                custom-class="tooltip"
                                style="width: 500px"
                                triggers="hover"
                              >
                                <span class="info-span"
                                  >Each {{ institution.label }} has its own
                                  Configurations. Set this
                                  {{ institution.label }} Configurations</span
                                >
                              </b-tooltip>
                            </h6>

                            <b-form-group label="" label-for="levels">
                              <p class="form-label">
                                {{
                                  `List each Course for this ${institution.label} e.g PHY101, CHE101 etc or your Custom Courses`
                                }}
                              </p>
                              <b-form-tags
                                :name="'nlevels' + level"
                                :id="'nlevels' + level"
                                :value="nlevcourse[index]"
                                @input="addCourses($event, level)"
                              >
                              </b-form-tags>
                            </b-form-group>

                            <b-form-group label="" label-for="suboffered">
                              <div class="tooltip-wrapper">
                                <p class="form-label">
                                  Number of Sections per Course (In order of Courses
                                  above) e.g 5, 5, 4
                                </p>
                                <b-icon-info-circle-fill
                                  id="tooltip-section-1"
                                  class="mt-1 cursor-pointer"
                                ></b-icon-info-circle-fill>
                                <b-tooltip
                                  target="tooltip-section-1"
                                  custom-class="tooltip"
                                  style="width: 500px"
                                  triggers="hover"
                                >
                                  <p class="info-span">
                                    *This is the number of sections the entire course
                                    could be splitted into usually determined by Topics or
                                    group of Topics
                                  </p>
                                  <br />
                                  <p class="info-span">
                                    *During the Test, the Sections will be labelled as
                                    'SECTION A', 'SECTION B'... For the Users
                                  </p>
                                  <br />
                                  <p class="info-span">
                                    *If you do not want to split the Course by sections,
                                    you can put the number of sections as 1.
                                  </p>
                                  <br />
                                  <p class="info-span">
                                    *Please ensure you fill this field in the same order
                                    as you inputed the courses above and seperate each
                                    with a Comma
                                  </p>
                                </b-tooltip>
                              </div>

                              <b-form-input
                                type="text"
                                :name="'coursection' + level"
                                :id="'coursection' + level"
                                @input="addConfig($event, level, 'sectionsperc')"
                                @focus="updateConfig('sectionsperc')"
                                @keyup="updateValue($event)"
                                remove-on-delete
                                aria-describedby="input-live-help input-live-feedback"
                                separator=""
                              >
                              </b-form-input>
                              <b-form-invalid-feedback id="input-live-feedback">
                                The Number of Seperated comma Items must equal the Number
                                of Courses in Courses Field
                              </b-form-invalid-feedback>

                              <!-- This is a form text block (formerly known as help block) -->
                              <b-form-text id="input-live-help"
                                >Number of Sections per Course.
                              </b-form-text>
                            </b-form-group>

                            <b-form-group label="" label-for="questpersect">
                              <div class="tooltip-wrapper">
                                <p class="form-label">
                                  Number of Questions per Section (In order of Courses
                                  above) e.g 5, 10, 15
                                </p>
                                <b-icon-info-circle-fill
                                  id="tooltip-questions-1"
                                  class="mt-1 cursor-pointer"
                                ></b-icon-info-circle-fill>
                                <b-tooltip
                                  target="tooltip-questions-1"
                                  custom-class="tooltip"
                                  style="width: 500px"
                                  triggers="hover"
                                >
                                  <span class="info-span"
                                    >*This is the number of questions that would be served
                                    in each section of the course as given above.</span
                                  ><br />
                                  <span class="info-span"
                                    >*Each Section will be served the same number of
                                    questions and the total number of questions in all
                                    sections gives the Total questions Served</span
                                  ><br />
                                  <span class="info-span"
                                    >*If you are not splitting the course into more than 1
                                    section, input the total number of Questions to be
                                    administered in that course</span
                                  ><br />
                                  <span class="info-span"
                                    >*Please ensure you fill this field in the same order
                                    as you inputed the courses above and seperate each
                                    with a Comma</span
                                  >
                                </b-tooltip>
                              </div>
                              <b-form-input
                                type="text"
                                :name="'coursequestion' + level"
                                :id="'coursequestion' + level"
                                value=""
                                @input="addConfig($event, level, 'questionsperc')"
                                @focus="updateConfig('questionsperc')"
                                @keyup="updateValue($event)"
                                remove-on-delete
                                aria-describedby="input-live-help input-live-feedback"
                                separator=" "
                              >
                              </b-form-input>
                              <b-form-invalid-feedback id="input-live-feedback">
                                The Number of Seperated comma Items must equal the Number
                                of Courses in Courses Field
                              </b-form-invalid-feedback>

                              <!-- This is a form text block (formerly known as help block) -->
                              <b-form-text id="input-live-help"
                                >Number of Sections per Course.
                              </b-form-text>
                            </b-form-group>

                            <b-form-group label="" label-for="coursetiming">
                              <div class="tooltip-wrapper">
                                <p class="form-label">
                                  Time in Minute per Course (In order of Courses above)
                                  e.g 30, 40, 60
                                </p>
                                <b-icon-info-circle-fill
                                  id="tooltip-time-1"
                                  class="mt-1 cursor-pointer"
                                ></b-icon-info-circle-fill>
                                <b-tooltip
                                  target="tooltip-time-1"
                                  custom-class="tooltip"
                                  style="width: 500px"
                                  triggers="hover"
                                >
                                  <span class="info-span"
                                    >*Input the total Time in minutes Users are allowed to
                                    write this Test</span
                                  ><br />
                                  <span class="info-span"
                                    >*This will be the time served to the counter anytime
                                    a student takes this course</span
                                  ><br />
                                  <span class="info-span"
                                    >*Please ensure you fill this field in the same order
                                    as you inputed the courses above and seperate each
                                    with a Comma</span
                                  >
                                </b-tooltip>
                              </div>

                              <b-form-input
                                type="text"
                                :name="'coursetime' + level"
                                :id="'coursetime' + level"
                                value=""
                                @input="addConfig($event, level, 'coursetiming')"
                                @focus="updateConfig('coursetiming')"
                                @keyup="updateValue($event)"
                                remove-on-delete
                                aria-describedby="input-live-help input-live-feedback"
                                separator=" "
                              >
                              </b-form-input>
                              <b-form-invalid-feedback id="input-live-feedback">
                                The Number of Seperated comma Items must equal the Number
                                of Courses in Courses Field
                              </b-form-invalid-feedback>

                              <!-- This is a form text block (formerly known as help block) -->
                              <b-form-text id="input-live-help"
                                >Time in Minute per Course
                              </b-form-text>
                            </b-form-group>

                            <b-form-group label="" label-for="totalmarks">
                              <div class="tooltip-wrapper">
                                <p class="form-label">
                                  Total Mark for each Course (In order of Courses above)
                                  e.g 60, 70, 100
                                </p>
                                <b-icon-info-circle-fill
                                  id="tooltip-totalmark-1"
                                  class="mt-1 cursor-pointer"
                                ></b-icon-info-circle-fill>
                                <b-tooltip
                                  target="tooltip-totalmark-1"
                                  custom-class="tooltip"
                                  style="width: 500px"
                                  triggers="hover"
                                >
                                  <span class="info-span"
                                    >*Input the Total marks each of the Courses is marked
                                    against</span
                                  ><br />
                                  <span class="info-span"
                                    >*This is very important for the marking system, to
                                    determine the weight of each question</span
                                  ><br />
                                  <span class="info-span"
                                    >*The weight of each Question is determined by the
                                    Total Marks/Total Questions</span
                                  ><br />
                                  <span class="info-span"
                                    >*Please ensure you fill this field in the same order
                                    as you inputed the courses above and seperate each
                                    with a Comma</span
                                  >
                                </b-tooltip>
                              </div>

                              <b-form-input
                                type="text"
                                :name="'coursetmark' + level"
                                :id="'coursetmark' + level"
                                value=""
                                @input="addConfig($event, level, 'totalmarks')"
                                @focus="updateConfig('totalmarks')"
                                @keyup="updateValue($event)"
                                remove-on-delete
                                aria-describedby="input-live-help input-live-feedback"
                                separator=" "
                              >
                              </b-form-input>
                              <b-form-invalid-feedback id="input-live-feedback">
                                The Number of Seperated comma Items must equal the Number
                                of Courses in Courses Field
                              </b-form-invalid-feedback>

                              <!-- This is a form text block (formerly known as help block) -->
                              <b-form-text id="input-live-help"
                                >Total Mark for each Course.
                              </b-form-text>
                            </b-form-group>

                            <b-form-group label="" label-for="available">
                              <div class="tooltip-wrapper">
                                <p class="form-label">
                                  Is the Course currently available for practice? (In
                                  order of Courses above) e.g Yes, No, No
                                </p>
                                <b-icon-info-circle-fill
                                  id="tooltip-available-1"
                                  class="mt-1 cursor-pointer"
                                ></b-icon-info-circle-fill>
                                <b-tooltip
                                  target="tooltip-available-1"
                                  custom-class="tooltip"
                                  style="width: 500px"
                                  triggers="hover"
                                >
                                  <span class="info-span"
                                    >*Is the Course available for Users to take the Test
                                    after adding?</span
                                  ><br />
                                  <span class="info-span"
                                    >*You are advised to put 'No' and come back to edit it
                                    to yes after questions for this course has been
                                    successfully added</span
                                  ><br />
                                  <span class="info-span"
                                    >*Please ensure you fill this field in the same order
                                    as you inputed the courses above and seperate each
                                    with a Comma</span
                                  >
                                </b-tooltip>
                              </div>

                              <b-form-input
                                type="text"
                                :name="'courseavailable' + level"
                                :id="'courseavailable' + level"
                                value=""
                                @input="addConfig($event, level, 'available')"
                                @focus="updateConfig('available')"
                                @keyup="updateValue($event)"
                                remove-on-delete
                                aria-describedby="input-live-help input-live-feedback"
                                separator=" "
                              >
                              </b-form-input>
                              <b-form-invalid-feedback id="input-live-feedback">
                                The Number of Seperated comma Items must equal the Number
                                of Courses in Courses Field
                              </b-form-invalid-feedback>

                              <!-- This is a form text block (formerly known as help block) -->
                              <b-form-text id="input-live-help"
                                >Is the Course currently available for
                                practice?</b-form-text
                              >
                            </b-form-group>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </b-form-group>

                  <b-form-group v-if="institution.structure == 'Subject'">
                    <b-form-group
                      v-if="$route.query.domain == 'base' || details.category != 'Organization'"
                      label=""
                      label-for="numsubjects"
                    >
                      <p class="form-label">
                        Number of Subjects Administered by this Testgroup at a Sitting
                      </p>
                      <b-form-spinbutton
                        id="numcourses"
                        v-model="institution.numcourses"
                        min="1"
                        max="15"
                      ></b-form-spinbutton>
                    </b-form-group>

                    <b-form-group v-if="details.category != 'Organization'" label="" label-for="tottime">
                      <p class="form-label">
                        Total time given for this Exam (in Minutes)
                      </p>
                      <b-form-spinbutton
                        id="totaltime"
                        v-model="institution.totaltime"
                        min="5"
                        max="500"
                        step="5"
                      ></b-form-spinbutton>
                    </b-form-group>

                    <b-form-group v-if="details.category != 'Organization'" label="" label-for="totmark">
                      <div class="tooltip-wrapper">
                        <p class="form-label">Total Mark alloted to the Exam</p>
                        <b-icon-info-circle-fill
                          id="tooltip-markalloted-1"
                          class="mt-1 cursor-pointer"
                        ></b-icon-info-circle-fill>
                        <b-tooltip
                          target="tooltip-markalloted-1"
                          custom-class="tooltip"
                          style="width: 500px"
                          triggers="hover"
                        >
                          <span class="info-span"
                            >*This the total Mark which the Whole test would be marked
                            against irrespective of the number of Subjects taken at a
                            sitting</span
                          ><br />
                          <span class="info-span"
                            >*It is very important in the Marking Process as it would be
                            used to determine the mark weight of each question</span
                          >
                        </b-tooltip>
                      </div>

                      <b-form-spinbutton
                        id="totmark"
                        v-model="institution.totalmarks"
                        min="10"
                        max="500"
                        step="5"
                      ></b-form-spinbutton>
                    </b-form-group>

                    <b-form-group label="" label-for="suboffered">
                      <div class="tooltip-wrapper">
                        <p class="form-label">
                          Subjects to be Administered from this Test group ( Input All )
                        </p>
                        <b-icon-info-circle-fill
                          id="tooltip-subjectad-1"
                          class="mt-1 cursor-pointer"
                        ></b-icon-info-circle-fill>
                        <b-tooltip
                          target="tooltip-subjectad-1"
                          custom-class="tooltip"
                          style="width: 500px"
                          triggers="hover"
                        >
                          <span class="info-span"
                            >*All the Subjects that would be administered by this
                            institution to its Users</span
                          ><br />
                          <span class="info-span"
                            >*This is different from the number of subjects that can be
                            adminstered at a sitting.</span
                          ><br />
                          <span class="info-span"
                            >*This includes all the various combinations that can be
                            offered at a sitting</span
                          >
                        </b-tooltip>
                      </div>

                      <b-form-tags
                        id="suboffered"
                        v-model="institution.subjects"
                      ></b-form-tags>
                    </b-form-group>

                    <b-form-group v-if="details.category != 'Organization'" label="" label-for="suboffered">
                      <div class="tooltip-wrapper">
                        <p class="form-label">
                          Input the Number of Questions given to each Subject Offered in
                          the exam IN THE SAME ORDER AS WRITTEN ABOVE. SEPERATE EACH ONE
                          BY A COMMA
                        </p>
                        <b-icon-info-circle-fill
                          id="tooltip-numberofquestions-1"
                          class="mt-1 cursor-pointer"
                        ></b-icon-info-circle-fill>
                        <b-tooltip
                          target="tooltip-numberofquestions-1"
                          custom-class="tooltip"
                          style="width: 500px"
                          triggers="hover"
                        >
                          <span class="info-span"
                            >*Input the Number of Questions each subject listed above
                            would administer for a sitting</span
                          ><br />
                          <span class="info-span"
                            >*It should be written in thesame order as the Subjects
                            Administered is written above</span
                          ><br />
                          <span class="info-span"
                            >*For example, some
                            {{
                              $route?.query?.domain == "base" ? "Institution" : "Group"
                            }}
                            may want to serve Mathematics or English with a Higher Number
                            of Questions, You have the Freedom to do that here</span
                          >
                        </b-tooltip>
                      </div>
                      <b-form-input
                        type="text"
                        id="suboffered"
                        v-model="getrawstring"
                        @input="addtoArray()"
                        remove-on-delete
                        :state="exceeds"
                        aria-describedby="input-live-help input-live-feedback"
                        separator=" "
                      >
                      </b-form-input>

                      <b-form-invalid-feedback id="input-live-feedback">
                        The Number of Seperated comma Items must equal the Number of
                        Subjects in Subjects Field
                      </b-form-invalid-feedback>

                      <!-- This is a form text block (formerly known as help block) -->
                      <b-form-text id="input-live-help"
                        >The Number of Questions given to each course in the Exam.
                      </b-form-text>
                    </b-form-group>

                    <b-form-group v-if="details.category != 'Organization'" label="" label-for="compsub">
                      <div class="tooltip-wrapper">
                        <p class="form-label">
                          Compulsory Subjects (Input Subjects compulsory for all
                          Candidates. If all is Compulsory, just type 'All')
                        </p>
                        <b-icon-info-circle-fill
                          id="tooltip-compulsory-1"
                          class="mt-1 cursor-pointer"
                        ></b-icon-info-circle-fill>
                        <b-tooltip
                          target="tooltip-compulsory-1"
                          custom-class="tooltip"
                          style="width: 500px"
                          triggers="hover"
                        >
                          <span class="info-span"
                            >*Are there any Compulsory Subjects you would want every User
                            been administered Test by this
                            {{
                              $route?.query?.domain == "base" ? "Institution" : "Group"
                            }}
                            to take? Input them here</span
                          >
                        </b-tooltip>
                      </div>

                      <b-form-tags
                        id="compsub"
                        v-model="institution.compsubjects"
                      ></b-form-tags>
                    </b-form-group>
                  </b-form-group>

                  <b-form-group
                    :label="`More Information about the ${
                      $route?.query?.domain == 'base' ? 'Institution' : 'Group'
                    }'s Test Structure :`"
                    label-for="institutioninfo"
                  >
                    <b-form-textarea
                      rows="4"
                      id="institutioninfo"
                      v-model="institution.institutioninfo"
                    >
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group class="text-center">
                    <div
                      v-if="institutionadded"
                      class="alert alert-dismissible alert-success p-3"
                    >
                      Testgroup has been Added
                    </div>

                    <div
                      v-if="institutionupdated"
                      class="alert alert-dismissible alert-success p-3"
                    >
                      Testgroup has been Updated
                    </div>
                    <div
                      v-if="incompleteerror"
                      class="alert alert-dismissible alert-danger p-3"
                    >
                      {{ incompleteerrormsg }}
                    </div>
                    <b-overlay
                      :show="uploading"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      class=""
                    >
                      <b-button
                        type="submit"
                        class="btn-sub p-1 w-50 mx-auto"
                        variant="success"
                      >
                        {{ $route.params.trackid ? "Update" : "Add" }}
                        {{ $route?.query?.domain == "base" ? "Institution" : "Group" }}
                      </b-button>
                    </b-overlay>
                  </b-form-group>
                </b-form-group>
              </b-card>
            </b-overlay>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      institution: this.getForm(),
      uploading: false,
      institutionadded: false,
      getrawstring: "",
      categoryarr: [],
      levelsconfig: [],
      classificationarray: [
        {
          text: "Level",
          value: "Level",
        },
        {
          text: "Class",
          value: "Class",
        },
        {
          text: "Term",
          value: "Term",
        },
        {
          text: "Part",
          value: "Part",
        },
        {
          text: "Year",
          value: "Year",
        },
        {
          text: "SS",
          value: "SS",
        },
        {
          text: "JSS",
          value: "JSS",
        },
      ],
      arrangmentarray: [
        {
          text: "Prefix (Label Comes first)",
          value: "prefix",
        },
        {
          text: "Suffix (Label Comes last)",
          value: "suffix",
        },
      ],
      currentlevel: 0,
      currentValue: "",
      currentConfig: "courses",
      incompleteerror: false,
      incompleteerrormsg: "",
      nlevcourse: [],
      label: "Level",
      fetching: false,
      institutionupdated: false
    };
  },
  created() {
    if (!this.loggedin) {
      this.$router.push({
        name: "login",
      });
    }
    if (this.details.clearance == "Normal") {
      this.$router.push({
        name: "welcome",
      });
    }
  },

  async mounted() {
    // This will get the Array of Values Object of the Institution's values
    await this.fetchCategories();
    await this.fetchAllInstitutions();

    this.setCurrentModule("Testgroups");

    let typesarr = this.Categories.filter(
      (x) => x.organization_name == this.details.clearance_organization
    ).map((x) => x.name);
    this.categoryarr = typesarr;

    if (this.$route.params.trackid) {
      this.fetchData();
    }
  },
  methods: {
    ...mapActions("admin", [
      "addinstitu",
      "updateInstitution",
      "fetchCategories",
      "fetchAllInstitutions",
      "fetchInstitution",
      "setCurrentModule"
    ]),

    getForm() {
      return {
        category: "Thirdparty",
        structure: "Subject",
        organization: "",
        organization_id: "",
        location: "",
        levels: [],
        totalmarks: 100,
        subjects: [],
        compsubjects: [],
        subnumque: [],
        name: "",
        institutioninfo: "",
        tabbed: null,
        available: null,
        sname: "",
        numcourses: 1,
        totalquestions: 0,
        label: "Levels",
        label_arrangement: "prefix",
        totaltime: 10,
        uploadedby: this.$store.state.loginmaster.details.fullname,
      };
    },
    setLevel(level) {
      this.currentlevel = level;
    },
    async fetchData() {
      this.fetching = true;
      try {
        const response = await this.fetchInstitution(this.$route.params.trackid);

        const institution = response.data;

        let subb = JSON.parse(institution.subjects_offered); // Subjects Offered
        let gsu = JSON.parse(institution.ques_per_sub).toString(); // Questions Per Subject Array (Obs)
        let compsubb = JSON.parse(institution.compulsory_subjects); // Compulsory Subejcts
        let levels = JSON.parse(institution.levels); // Levels of the Institution, if it is Section
        let levelconfig = JSON.parse(institution.levels_config); // Configuration Object of each Level

        this.institution.levels = levels;
        this.levelsconfig = levelconfig;

        this.institution = {
          category: institution.category,
          structure: institution.structure,
          location: institution.location,
          markperquest: Number(institution.mark_per_question),
          totalmarks: Number(institution.total_marks),
          levels: levels,
          subjects: subb,
          compsubjects: compsubb,
          name: institution.name,
          institutioninfo: institution.institution_info,
          subnumque: JSON.parse(institution.ques_per_sub),
          tabbed: institution.tabbed,
          available: institution.available,
          sname: institution.short_name,
          classifier: institution.classifier,
          label: institution.label,
          label_arrangement: institution.label_arrangement,
          numcourses: Number(institution.num_courses),
          totaltime: Number(institution.total_time),
          totalquestions: Number(institution.total_questions),
          trackid: institution.track_id,
        };

        // Get the Courses For n Number of Levels for this institution from the Courses Array in order

        this.levelsconfig.forEach((curval, index) => {
          // n here stands for the levels(classifier) added. n could be 100, 200 or 1,2 or 1st, 2nd depending on the classifier used
          let localnlevcourse = curval.config
            .filter((x) => x.name == "courses")
            .map((x) => x.values);
          // The nlevelcourse variable stores the array of courses for each level in correct index order.
          this.nlevcourse[index] = localnlevcourse[0];
        });

        this.$nextTick(() => {
          this.levelsconfig.forEach((curval) => {
            // The Fields has been given dynamic IDs according to the Level it falls under. So the "curval.name" attaches the Level to create the dynamic ID here
            // If the Loop is currently on an 100 Level Config the "curval.name" will be 100 there by created an ID : "coursesection100"
            let coursesid = `coursection${curval.name}`;
            // Creates a variable and stores the filtered and mapped values in it
            let coursesval = curval.config
              .filter((x) => x.name == "sectionsperc")
              .map((x) => x.values);

            // console.log(coursesval, coursesid, document.getElementById(coursesid));
            // Updates the document via the dynamic ID with the value retrieved
            document.getElementById(coursesid).value = coursesval[0];

            // Repeats same step above for the others
            let courseqid = `coursequestion${curval.name}`;
            let courseqval = curval.config
              .filter((x) => x.name == "questionsperc")
              .map((x) => x.values);
            document.getElementById(courseqid).value = courseqval[0];

            let coursetid = `coursetime${curval.name}`;
            let coursetval = curval.config
              .filter((x) => x.name == "coursetiming")
              .map((x) => x.values);
            document.getElementById(coursetid).value = coursetval[0];

            let coursetmid = `coursetmark${curval.name}`;
            let coursetmval = curval.config
              .filter((x) => x.name == "totalmarks")
              .map((x) => x.values);
            document.getElementById(coursetmid).value = coursetmval[0];

            let courseaid = `courseavailable${curval.name}`;
            let courseaval = curval.config
              .filter((x) => x.name == "available")
              .map((x) => x.values);
            document.getElementById(courseaid).value = courseaval[0];
          });
        });
        // // After the Level and Courses Field has been Updated...

        this.getrawstring = gsu;
        // //let subnum =

        this.fetching = false;
      } catch (err) {
        console.log(err);
        this.fetching = false;
      }
    },
    confirmunder() {
      for (let i = 0; i < this.levelsconfig.length; i++) {
        //console.log(i)

        for (let j = 0; j < this.levelsconfig[i].config.length; j++) {
          //console.log(this.levelsconfig[i].config.length)
          //console.log(j)
          let there3 = this.levelsconfig[i].config.findIndex(
            (con) => con.name == "courses"
          );

          if (there3 == -1) {
            return false;
          } else {
            if (
              this.levelsconfig[i].config[there3].values.length !=
                this.levelsconfig[i].config[j].values.length ||
              this.levelsconfig[i].config.length != 6
            ) {
              this.incompleteerror = true;
              this.incompleteerrormsg =
                "One or More Fields is either too much or too few and does not tally with the number of courses Inputed. Correct it before it can be added.";
              return false;
            } else {
              //console.log("Everything de alright")
              if (i + 1 == this.levelsconfig.length) {
                if (j + 1 == this.levelsconfig[i].config.length) {
                  return true;
                }
              }
            }
          }
        }
      }
    },
    addtoArray() {
      let rawstring = this.getrawstring;
      // console.log(rawstring);
      let strarray = "";
      if (rawstring.length > 0) {
        strarray = rawstring.split(",");
      }
      // console.log(strarray);
      this.institution.subnumque = strarray;
    },
    addInst() {
      this.incompleteerror = false;
      this.uploading = true;

      this.institution.organization = this.details.clearance_organization;
      this.institution.organization_id = this.details.clearance_organization_id;

      if (this.institution.category == "Undergraduate") {
        if (this.confirmunder()) {
          this.institution.levelsconfig = this.levelsconfig;

          this.addinstitu(this.institution).then(() => {
            this.institutionadded = true;
            this.uploading = false;
            this.institution = this.getForm();

            if (
              this.details.clearance_organization == "Quicktest"
            ) {
              this.leaving = true;
              this.$router.push({ name: "listinstitution" });
            } else {
              this.leaving = true;
              this.$router.push({ name: "listtestgroups" });
            }
          });
        } else {
          this.uploading = false;
          return false;
        }
      } else {
        let subnum = this.getrawstring;
        //console.log(subnum);
        let subns = "";
        if (subnum.length > 0) {
          subns = subnum.split(",");
        }

        //console.log(subns)
        this.institution.subnumque = subns;
        this.institution.levelsconfig = this.levelsconfig;

        this.addinstitu(this.institution).then(() => {
          this.uploading = false;
          this.institutionadded = true;
          this.institution = this.getForm();

          if (
            this.details.clearance_organization == "Quicktest"
          ) {
            this.leaving = true;
            this.$router.push({ name: "listinstitution" });
          } else {
            this.leaving = true;
            this.$router.push({ name: "listtestgroups" });
          }
        });
      }
    },
    setInstitution() {
      this.incompleteerror = false;
      this.uploading = true;
      //console.log(this.institution)
      if (this.institution.structure == "Section") {
        if (this.confirmunder()) {
          this.institution.levelsconfig = this.levelsconfig;

          this.updateInstitution(this.institution).then(() => {
            this.institutionupdated = true;
            this.uploading = false;
            this.sent = false;

            if (
              this.details.clearance_organization == "Quicktest"
            ) {
              this.leaving = true;
              this.$router.push({ name: "listinstitution" });
            } else {
              this.leaving = true;
              this.$router.push({ name: "listtestgroups" });
            }
          });
        } else {
          this.uploading = false;
          return false;
        }
      } else {
        let subnum = this.getrawstring;
        //console.log(subnum);
        let subns = "";
        if (subnum.length > 0) {
          subns = subnum.split(",");
        }

        //console.log(subns)
        this.institution.subnumque = subns;
        this.institution.levelsconfig = this.levelsconfig;

        this.updateInstitution(this.institution).then(() => {
          this.institutionupdated = true;
          this.uploading = false;
          this.sent = false;

          if (
            this.details.clearance_organization == "Quicktest"
          ) {
            this.leaving = true;
            this.$router.push({ name: "listinstitution" });
          } else {
            this.leaving = true;
            this.$router.push({ name: "listtestgroups" });
          }
        });
      }
    },
    addLevels(level) {
      let arrlength = level.length;
      let lastindex = arrlength - 1;

      // Check if the Level exists in the Levels tag input from users. If it doesnt exist, means user has removed it. Then Remove it from the Config
      for (let i = 0; i < this.levelsconfig.length; i++) {
        let there = level.findIndex((name) => name == this.levelsconfig[i].name);

        if (there == -1) {
          //alert("We nor see am for there")
          this.levelsconfig.splice(i, 1);
        } else {
          //alert("Be Like say e day o")
        }
      }

      // Check if the Level is already in the config Object. If it is there don't don anything, we dont want duplication. But if its not there, Add it to the array
      for (let i = 0; i <= this.levelsconfig.length; i++) {
        let there = this.levelsconfig.findIndex((con) => con.name == level[lastindex]);

        if (there == -1) {
          this.levelsconfig.push({
            name: level[lastindex],
            config: [],
            visible: true,
          });
        } else {
          //alert("It has been there. abeg nor duplicate this thing abeg")
        }
      }
    },
    addCourses(courses, level) {
      let arrlength = courses.length;
      let lastindex = arrlength - 1;

      let there = this.levelsconfig.findIndex((lev) => lev.name == level);
      //console.log(courses)
      let courseconfig = {
        name: "courses",
        values: courses,
      };

      if (there == -1) {
        // If there's no Level there yet which is very unnlikely to happen, stop here.
        // Do Nothing
      } else {
        let configlen = this.levelsconfig[there].config.length;

        //let theresc = this.levelsconfig[there].config.findIndex(con => con.name == "sections")

        // Check if the Config for this level has any values
        if (configlen > 0) {
          // If it has, meaning its not a First input into the Object, therefore we need to do some validation and duplication checks
          let coursesconfig = this.levelsconfig[there].config[0].values; // Get the current Courses in the Courses Array

          // On User Input into the Tag input, we don't know if it was a removal or addition. This IF BLock will check if it was a removal or addition
          if (arrlength > 0) {
            // Loop through the Current courses in the Config Object for this Level
            for (let j = 0; j <= coursesconfig.length; j++) {
              // Check if the each element in the courses config appear in the Course Array from user input.
              let there3 = courses.findIndex((name) => name == coursesconfig[j]);
              //console.log(`j is --- ${j}`)
              if (there3 == -1) {
                // IF it does not appear, meaning User Perform a Removal therefore remove it from the Config Object
                this.levelsconfig[there].config[0].values.splice(j, 1);
              }
            }
          }
          // Now we want to push the new entry from the user into the courses array of the config object
          // Already we've checked if it was removal from the above IF Block

          // Get the Index if it exists from the courses Array
          let there2 = coursesconfig.findIndex((con) => con == courses[lastindex]);

          if (there2 == -1) {
            // If it does not exist, Meaning it is not there, it can then be pushed into the Array
            this.levelsconfig[there].config[0].values.push(courses[lastindex]);
          }
        } else {
          // It does not have any value. Therefore Push in the new values without performing any duplication or validation checks
          this.levelsconfig[there].config.push(courseconfig);
        }
      }
    },

    getVisible(level) {
      let there = this.levelsconfig.findIndex((lev) => lev.name == level);

      if (there == -1) {
        // If there's no Level there yet which is very unnlikely to happen, stop here.
        // Do Nothing
        return false;
      } else {
        let visible = this.levelsconfig[there].visible;

        // Check if the Config for this level has any values
        if (visible) {
          return true;
        } else {
          return false;
        }
      }
    },

    closeVisible(level) {
      let there = this.levelsconfig.findIndex((lev) => lev.name == level);

      if (there == -1) {
        // If there's no Level there yet which is very unnlikely to happen, stop here.
        // Do Nothing
        return false;
      } else {
        // let visible = this.levelsconfig[there].visible;

        this.levelsconfig[there].visible = !this.levelsconfig[there].visible;

        // Check if the Config for this level has any values
        // if (visible) {
        //   return true
        // }else{
        //   return false
        // }
      }
    },

    addConfig(value, level, config) {
      let valleng = value.length;

      let valuearr = value.split(",");
      //let lastindex = arrlength - 1;
      let there = this.levelsconfig.findIndex((lev) => lev.name == level);

      let configvalue = {
        name: "",
        values: "",
      };

      if (valleng > 0) {
        configvalue = {
          name: config,
          values: valuearr,
        };
      } else {
        configvalue = {
          name: config,
          values: [],
        };
        valuearr = [];
      }

      if (there == -1) {
        // If there's no Level there yet which is very unnlikely to happen, stop here.
        // Do Nothing
      } else {
        let configlen = this.levelsconfig[there].config.length;

        // Check if the Config for this level has any values
        if (configlen > 0) {
          let theresc = this.levelsconfig[there].config.findIndex(
            (con) => con.name == config
          );

          if (theresc == -1) {
            this.levelsconfig[there].config.push(configvalue);
          } else {
            let there4 = this.levelsconfig[there].config.findIndex(
              (con) => con.name == config
            );
            //let sectionsconfig = this.levelsconfig[there].config[there4].values // Get the current Courses in the Courses Array

            this.levelsconfig[there].config[there4].values = valuearr;
          }
          // If it has, meaning its not a First input into the Object, therefore we need to do some validation and duplication checks
        }
      }
    },
    updateValue($event) {
      //console.log($event.target.value)
      this.currentValue = $event.target.value;
    },
    updateConfig(curconfig) {
      this.currentConfig = curconfig;
    },
    categoryChanged() {
      // let tabi = this.Categories.filter(
      //     (x) => x.organization_name == org && x.name == this.institution.category
      // ).map((x) => x.structure);
      // this.institution.structure = tabi[0];
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      loggedin: (state) => state.loginmaster.loggedIn,
      Categories: (state) => state.admin.Categories,
      institutionsarr: (state) => state.admin.listinstitutions,
      editinstitution: (state) => state.admin.editinstitution[0],
    }),

    exceeds() {
      let subnum = this.getrawstring;
      let subnumsp = "";

      if (this.institution.structure != "Sections") {
        if (subnum.length > 0) {
          subnumsp = subnum.split(",");

          if (subnumsp.length != this.institution.subjects.length) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    disFirst() {
      let there = this.levelsconfig.findIndex((lev) => lev.name == this.currentlevel);
      if (there == -1) {
        return true;
      } else {
        let configlen = this.levelsconfig[there].config.length;
        let there3 = this.levelsconfig[there].config.findIndex(
          (con) => con.name == "courses"
        );
        //console.log(there3)
        //alert(there3)

        //return (configlen < 0 || there3 == - 1) ? true : false
        if (configlen < 0 || there3 == -1) {
          return true;
        } else {
          return false;
        }
      }
      //return false
    },
    levEx() {
      let there = this.levelsconfig.findIndex((lev) => lev.name == this.currentlevel);

      if (there == -1) {
        return false;
      } else {
        let there3 = this.levelsconfig[there].config.findIndex(
          (con) => con.name == "courses"
        );

        let valuearr = this.currentValue.split(",");
        let arrlength = valuearr.length;

        if (there3 == -1) {
          return false;
        } else {
          let exce = this.levelsconfig[there].config[there3].values.length;

          if (this.currentValue.length > 0) {
            if (arrlength != exce) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.tooltip {
  width: 700px;
}

.tooltip-wrapper {
  display: flex;
  flex: row wrap;
  gap: 10px;
}

.level-wrapper {
  padding: 13px 20px;
  background: rgb(246, 244, 244);
  border: 1px solid black;
  border-radius: 10px 10px;
}

.head-wrapper {
  display: flex;
  flex: row wrap;
  gap: 10px;
  justify-content: space-between;
  background: rgb(246, 244, 244);
}

.info-span {
  display: block;
  text-align: left;
  color: white;
}

.form-label {
  font-weight: semi-bold;
  font-size: 20px;
}
</style>
